const footnoteLinks = ($) => {
  const links = document.querySelectorAll('a.see-footnote, a.footnote-label');

  for (const link of links) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      const footnote = document.getElementById(href.slice(1));
      console.log(footnote.offsetTop);
      $([document.documentElement, document.body]).animate({
        scrollTop: footnote.getBoundingClientRect().top + document.documentElement.scrollTop - 150,
      }, 1000);
    });
  }
};

document.addEventListener('DOMContentLoaded', footnoteLinks(jQuery));
